import { css } from 'linaria';
import { createAdaptiveComponent } from './create-adaptive-component';

const fromTablet = css`
  display: none;

  @media (--from-tablet) {
    display: contents;
  }
`;

export const FromTablet = createAdaptiveComponent({
  displayName: 'FromTablet',
  ssrClassName: fromTablet,
});
